<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
   import moment from 'moment';

   export default {
      page: {
         title: "Add Truck",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         const current_year = moment().format("YYYY");

         return {
            title: "Add Truck",
            items: [
               {
                  text: "Trucks",
                  href: "/trucks",
               },
               {
                  text: "Add Truck",
                  active: true,
               },        
            ],
            truck: {
               id: '',
               truck_no : '',
               manufacturer: '',
               manufactured_year: '',
               model: '',
               color: '',
               chassis_no: '',
               engine_no: '',
               fuel_station: '',
               mot_certificate: '',
               insurance_certificate: '',
               truck_certificate: '',

            },
            token: "",
            errors: {}, 
            fuelstations:[],
            preview_mot_image: "",
           ins_preview_image: "",
            cert_preview_image: "",
            mot_image: "",
            ins_image: "",
            cert_image: "",
            year: current_year,
         };
      },
      mounted() {
         this.fetchFuelStations();
      },

      methods: {
         fetchFuelStations() {  

               let url = "api/admin/getFuelStationnames";         
               this.getToken();
               this.$axios
                  .get(url, { headers: { Authorization: "Bearer " + this.token } })
                  .then((res) => {
                     var responseData = res.data.data;
                     console.log(responseData);
                     this.fuelstations = responseData.fuel_stations;
                     this.fuelstations_visible = true;
                  })
                  .catch((err) => console.log(err));
                  
               },
               setMot(e) {
                  this.mot_image = e.target.files[0];
                  this.preview_mot_image = URL.createObjectURL(e.target.files[0]);
               },
               setIns(e) {
                  this.ins_image = e.target.files[0];
                  this.ins_preview_image = URL.createObjectURL(e.target.files[0]);
               },
               setCert(e) {
                  this.cert_image = e.target.files[0];
                  this.cert_preview_image = URL.createObjectURL(e.target.files[0]);
               },
         addTruck() {
           // alert(this.year);
            //alert(this.truck.manufactured_year);

            this.getToken();

            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/admin/truck/add";             
       
            let formData = new FormData();
            formData.append("truck_no", this.truck.truck_no); 
            formData.append("manufacturer", this.truck.manufacturer); 
            formData.append("manufactured_year", this.truck.manufactured_year); 
            formData.append("model", this.truck.model); 
            formData.append("color", this.truck.color); 
            formData.append("chassis_no", this.truck.chassis_no); 
            formData.append("engine_no", this.truck.engine_no); 
            formData.append("fuel_station", this.truck.fuel_station); 

            formData.append('mot_certificate', this.mot_image)  ;
            formData.append('insurance_certificate', this.ins_image);
            formData.append('truck_certificate', this.cert_image);


           
            this.$axios
            .post(url, formData, config)
            .then((res) => {
               console.log(res);

               if(res.status == 200) {
                 

                     this.$swal("", res.data.message, "success");
                
                  this.clearForm();
                  this.$router.push({ name: 'trucks'});
               }
               })
               .catch((error) => {
            console.log(error);
            console.log(error.response);
            if (error.response) {
               if(error.response.status == 422) {               
                  if (error.response.data) {
                     this.errors = error.response.data.message;
                  } 
                  this.$swal("", error.response.statusText, "error");
                  
               } else if(error.response.status == 500) {
                  this.$swal("", error.response.statusText, "error");
               } 
               else if(error.response.status == 401) {
                  this.$swal("", error.response.statusText, "error");
                  this.$router.push({ name: "login" });
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
            } else {
               this.$swal("", error.message, "error");
            }
            
         });
            //.finally(() => (this.loading = false));
         },
         getToken() {
         if (localStorage.getItem('sigofuel_admin')) {
            var sigofuel_admin =  JSON.parse(localStorage.getItem('sigofuel_admin'));
            if(sigofuel_admin.token) {
               this.token = sigofuel_admin.token;
            } else {
               this.$swal("", "Failed to fetch token, please login again", "error");
               this.$router.push({ name: "login" });
            }
               
         } else {
            this.$swal("", "Session expired, please login again", "error");
            this.$router.push({ name: "login" });
         }
      },
      clearForm() {
      this.truck.truck_no = '';
      this.truck.manufacturer = '';
      this.truck.manufactured_year = '';
      this.truck.model = '';
      this.truck.color = '';
      this.truck.chassis_no = '';
      this.truck.engine_no = '';
      this.truck.fuel_station = '';
     
      this.truck.mot_certificate = '';
      this.truck.insurance_certificate = '';
      this.truck.truck_certificate = '';


      this.mot_image = '';
      this.preview_mot_image = '';

      this.ins_image = '';
      this.ins_preview_image = '';

      this.cert_image = '';
      this.cert_preview_image = '';

      this.errors = {};
}
         
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">

                  <!----- top button area starts---->
                  <div class="row mb-2">
                     <div class="col-12">
                        <router-link :to="{ name: 'trucks' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->
                  
                  <!-- <b-card header-class="bg-transparent border-light" class="border border-light"> -->
                     <form class="form-horizontal" role="form" @submit.prevent="addTruck()">
                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           
                           <div class="row">
                              <div class="form-group col-md-4">
                                 <label>Truck No. <span class="text-danger">*</span></label>
                                 <input type="text" class="form-control" v-model="truck.truck_no"   v-bind:class="{ 'is-invalid': Boolean(errors.truck_no) }"/>
                                 <div v-for="(val, index) in errors.truck_no" :key="index" class="invalid-feedback">
                                       <p class="mb-0">{{ val }}</p>
                                    </div>
                              </div>                    
                          
                              <div class="form-group col-md-4">
                                 <label>Manufacturer <span class="text-danger">*</span></label>
                                 <input type="text" class="form-control" v-model="truck.manufacturer"   v-bind:class="{ 'is-invalid': Boolean(errors.manufacturer) }" />
                                 <div v-for="(val, index) in errors.manufacturer" :key="index" class="invalid-feedback">
                                       <p class="mb-0">{{ val }}</p>
                                    </div>
                              </div>

                              <div class="form-group col-md-4">
                                 <label>Manufactured Year <span class="text-danger">*</span></label>
                                 <input type="number" placeholder="YYYY" min="1999" :max="parseInt(year)" class="form-control" v-model="truck.manufactured_year"   v-bind:class="{ 'is-invalid': Boolean(errors.manufactured_year) }"/>
                                 <div v-for="(val, index) in errors.manufactured_year" :key="index" class="invalid-feedback">
                                       <p class="mb-0">{{ val }}</p>
                                    </div>
                              </div>

                              <div class="form-group col-md-4">
                                 <label>Model <span class="text-danger">*</span></label>
                                 <input type="text" class="form-control" v-model="truck.model"   v-bind:class="{ 'is-invalid': Boolean(errors.model) }" />
                                 <div v-for="(val, index) in errors.model" :key="index" class="invalid-feedback">
                                       <p class="mb-0">{{ val }}</p>
                                    </div>
                              </div>

                              <div class="form-group col-md-4">
                                 <label>Colour <span class="text-danger">*</span></label>
                                 <input type="text" class="form-control" v-model="truck.color"   v-bind:class="{ 'is-invalid': Boolean(errors.color) }"/>
                                 <div v-for="(val, index) in errors.color" :key="index" class="invalid-feedback">
                                       <p class="mb-0">{{ val }}</p>
                                    </div>
                              </div>

                              <div class="form-group col-md-4">
                                 <label>Chassis No. <span class="text-danger">*</span></label>
                                 <input type="text" class="form-control" v-model="truck.chassis_no"   v-bind:class="{ 'is-invalid': Boolean(errors.chassis_no) }" />
                                 <div v-for="(val, index) in errors.chassis_no" :key="index" class="invalid-feedback">
                                       <p class="mb-0">{{ val }}</p>
                                    </div>
                              </div>

                              <div class="form-group col-md-4">
                                 <label>Engine No. <span class="text-danger">*</span></label>
                                 <input type="text" class="form-control" v-model="truck.engine_no"   v-bind:class="{ 'is-invalid': Boolean(errors.engine_no) }"/>
                                 <div v-for="(val, index) in errors.engine_no" :key="index" class="invalid-feedback">
                                       <p class="mb-0">{{ val }}</p>
                                    </div>
                              </div>

                              <div class="form-group col-md-4">
                                 <label>Fuel Station <span class="text-danger">*</span></label>
                                 <select class="form-control" v-model="truck.fuel_station" v-bind:class="{ 'is-invalid': Boolean(errors.fuel_station) }">
                                    <option value="">Select</option>
                                    <option :value="fuelstation.user_id" v-for="fuelstation in fuelstations" :key="fuelstation.user_id">
                                       <span v-if="fuelstation.name_en != null">
                                  {{fuelstation.name_en}}
                                  </span>
                                  <span v-else>{{fuelstation.name_so}}</span></option>
                                 </select>
                                 <div v-for="(val, index) in errors.fuel_station" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div>
                   
                              
                           </div>
                        </b-card>


                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           <h4 class="font-size-16 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Certificates</h4>

                           <div class="row">
                              <div class="form-group col-md-6">
                                 <label>MOT Certificate <span class="text-danger">*</span><span class="small">[Allowed formats: .jpg, .jpeg, .png]</span></label>
                                 <input type="file" @change="setMot($event)" accept=".png,.jpg,.jpeg" class="form-control" :class="{ 'is-invalid': Boolean(errors.mot_certificate) }">
                                 <img v-if="preview_mot_image" class="avatar-sm mt-2" :src="preview_mot_image">

                                 <div v-for="(val, index) in errors.mot_certificate" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div>
                           </div>
                        
                           <div class="row">
                              <div class="form-group col-md-6">
                                 <label>Insurance Certificate <span class="text-danger">*</span><span class="small">[Allowed formats: .jpg, .jpeg, .png]</span></label>
                                 <input type="file" @change="setIns($event)" accept=".png,.jpg,.jpeg" class="form-control" :class="{ 'is-invalid': Boolean(errors.insurance_certificate) }">
                                 <img v-if="ins_preview_image" class="avatar-sm mt-2" :src="ins_preview_image">

                              <div v-for="(val, index) in errors.insurance_certificate" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                              </div>
                           </div>

                           <div class="row">
                              <div class="form-group col-md-6">
                                 <label>Truck Certificate <span class="text-danger">*</span><span class="small">[Allowed formats: .jpg, .jpeg, .png]</span></label>
                                 <input type="file" @change="setCert($event)" accept=".png,.jpg,.jpeg" class="form-control" :class="{ 'is-invalid': Boolean(errors.insurance_certificate) }">
                                 <img v-if="cert_preview_image" class="avatar-sm mt-2" :src="cert_preview_image">

                           <div v-for="(val, index) in errors.truck_certificate" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                              </div>
                           </div>
                        </b-card>                    


                        <div class="row mt-3">
                           <div class="12">
                              <button class="btn btn-primary me-2" type="submit">Save</button>
                              <router-link :to="{ name: 'trucks' }" class="btn btn-light">Cancel</router-link>
                           </div>
                        </div>
                     </form>
                  <!-- </b-card> -->
               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
